import { render, staticRenderFns } from "./JointsParameterList.vue?vue&type=template&id=bebf980e&scoped=true"
import script from "./JointsParameterList.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsParameterList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsParameterList.vue?vue&type=style&index=0&id=bebf980e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebf980e",
  null
  
)

export default component.exports